import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CARD_PADDING_HORIZONTAL, CARD_SPACING, CARD_SPACING_REDUCED } from "../card-layout/constants";
import { CELL_SPACING_VERTICAL, CELL_SPACING_VERTICAL_REDUCED } from "../html/constants";
import { TableSpacing } from "../interfaces";
export var mapIndexesToBooleans = function mapIndexesToBooleans(data) {
  var result = {};
  data.forEach(function (_, index) {
    result[index] = false;
  });
  return result;
};
export var setAllValuesToFalse = function setAllValuesToFalse(obj) {
  var result = {};
  Object.entries(obj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    result[key] = false;
  });
  return result;
};
export var getVerticalSpacingForCell = function getVerticalSpacingForCell(spacing) {
  return spacing === TableSpacing.Reduced ? CELL_SPACING_VERTICAL_REDUCED : CELL_SPACING_VERTICAL;
};
export var getPaddingForCard = function getPaddingForCard(theme, spacing) {
  if (!spacing) {
    spacing = theme.mode === 'dense' ? TableSpacing.Reduced : TableSpacing.Default;
  }

  var paddingHorizontal = theme.selectors.space(CARD_PADDING_HORIZONTAL);
  var paddingVertical = theme.selectors.space(spacing === TableSpacing.Reduced ? CARD_SPACING_REDUCED : CARD_SPACING) / 2;
  return [paddingHorizontal, paddingVertical];
};
export var getMaxExpandableRows = function getMaxExpandableRows(columns, data, index) {
  return columns.reduce(function (max, col) {
    if (!!col.expandableContent) {
      var expandableRowsCount = col.expandableContent({
        data: data,
        index: index
      }).length;
      return expandableRowsCount > max ? expandableRowsCount : max;
    }

    return max;
  }, 0);
};